import script from "./xtx-steps-item.vue?vue&type=script&lang=js"
export * from "./xtx-steps-item.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__